var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('nav',{staticClass:"nav-inicio"},[_c('div',{staticClass:"container-fluid"},[_c('h2',{staticClass:"title"},[_vm._v("SICA")])])])])
}]

export { render, staticRenderFns }